import React from "react";
import { formatTime } from '../../utils/sectorDataUtils';
import { ArrowLeft, ArrowRight } from "lucide-react";

interface TimeSliderProps {
  dates: string[];
  currentDateIndex: number;
  onChange: (index: number) => void;
}

const TimeSlider: React.FC<TimeSliderProps> = ({
  dates,
  currentDateIndex,
  onChange,
}) => {
  const formatDate = (date: string) => {
    // Check if the date is in ISO format (YYYY-MM-DD)
    if (date.includes('-')) {
      const d = new Date(date);
      return d.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric',
        year: 'numeric'
      });
    }
    // If not ISO format, assume it's a time string (HH:mm)
    return formatTime(date);
  };

  return (
    <div className="space-y-3 sm:space-y-4">
      <div className="text-center text-xs sm:text-sm text-white/60">
        {formatDate(dates[currentDateIndex])}
      </div>
      <div className="flex justify-center items-center gap-2 sm:gap-4">
        <button 
          onClick={() => onChange(Math.max(0, currentDateIndex - 1))}
          disabled={currentDateIndex === 0}
          className="p-1.5 sm:p-2 rounded-lg bg-black/20 hover:bg-white/5 disabled:opacity-30"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
        <input
          type="range"
          min={0}
          max={dates.length - 1}
          value={currentDateIndex}
          onChange={(e) => onChange(Number(e.target.value))}
          className="w-full accent-white/40"
        />
        <button 
          onClick={() => onChange(Math.min(dates.length - 1, currentDateIndex + 1))}
          disabled={currentDateIndex === dates.length - 1}
          className="p-1.5 sm:p-2 rounded-lg bg-black/20 hover:bg-white/5 disabled:opacity-30"
        >
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default TimeSlider;
